import React from "react";

/**
 * Shared layout primitives for the storage "Connect" modals
 * (ConnectStorageModal for NAS, ConnectS3Modal, ConnectAzureModal) —
 * extracted so the three don't copy-paste-drift from each other, mirroring
 * the backend's own explicit anti-drift convention for the per-kind
 * _safe_*_for_storage functions.
 */

export function Section({ title, children }) {
    return (
        <div>
            <div className="mb-1.5 font-mono text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
                {title}
            </div>
            {children}
        </div>
    );
}

export function Field({ label, required, children }) {
    return (
        <label className="block">
            <span className="mb-1 block text-[11px] font-medium text-muted-foreground">
                {label}{required && <span className="ml-0.5 text-[#00C2FF]">*</span>}
            </span>
            {children}
        </label>
    );
}

export function RadioPill({ active, onClick, label, sub, testId }) {
    return (
        <button
            type="button"
            onClick={onClick}
            data-testid={testId}
            className={[
                "flex min-w-[160px] items-center gap-3 rounded-lg border px-4 py-2.5 text-left transition-all",
                active
                    ? "border-[#00C2FF] bg-[#00C2FF]/10 shadow-sm"
                    : "border-border hover:border-foreground/30",
            ].join(" ")}
        >
            <div
                className={[
                    "flex h-4 w-4 items-center justify-center rounded-full border-2 transition-colors",
                    active ? "border-[#00C2FF]" : "border-muted-foreground/50",
                ].join(" ")}
            >
                {active && <div className="h-2 w-2 rounded-full bg-[#00C2FF]" />}
            </div>
            <div>
                <div className="text-sm font-semibold">{label}</div>
                <div className="text-[10px] text-muted-foreground">{sub}</div>
            </div>
        </button>
    );
}
